(function() {
  let scrollPosition = 0;

  function initializePjax() {
    if (typeof Pjax === 'undefined' || window.myThemePjaxInstance) { return; }
    const productSection = document.querySelector('.product-section');
    if (!productSection) return;
    const sectionId = productSection.id.replace('shopify-section-', '');
    try {
      const pjax = new Pjax({
        elements: "a[data-pjax-link]",
        selectors: ['title', `#ProductInfo-${sectionId}`, `#MediaGallery-${sectionId}`],
        cacheBust: false,
        timeout: 5000,
        scrollTo: false
      });
      window.myThemePjaxInstance = pjax;
      document.addEventListener('pjax:send', () => {
        scrollPosition = window.pageYOffset;
        const productGrid = document.querySelector('.product-grid-container');
        if (productGrid) productGrid.classList.add('is-loading');
      });
      document.addEventListener('pjax:complete', () => {
        window.scrollTo({ top: scrollPosition, behavior: 'instant' });
        const productGrid = document.querySelector('.product-grid-container');
        if (productGrid) productGrid.classList.remove('is-loading');
        initializeBundleSelectors();
      });
    } catch (e) { console.error("PJAX Initialization Failed:", e); }
  }

  class BundleSelector {
    constructor(container) {
      this.container = container;
      this.radioButtons = this.container.querySelectorAll('.package-selector__radio-input');
      this.sectionId = this.container.dataset.sectionId;
      this.mainProductForm = document.getElementById(`product-form-${this.sectionId}`);
      this.variantSelectsComponent = document.querySelector(`variant-selects[data-section="${this.sectionId}"]:not([data-sticky])`) || document.querySelector(`variant-selects[data-section="${this.sectionId}"]`);
      this.variantDataScript = this.container.querySelector('[data-bundle-variants]');
      this.productWrapper = this.container.closest('.thb-product-detail') || document.querySelector('.thb-product-detail');
      this.productSlider = this.productWrapper ? this.productWrapper.querySelector('.product-images') : null;
      this.thumbnails = this.productWrapper ? this.productWrapper.querySelector('.product-thumbnail-container') : null;
      this.attachEvents();
      this.updateIncludesVisibility();
    }

    attachEvents() {
      this.radioButtons.forEach(radio => {
        radio.addEventListener('change', (event) => {
          this.updateIncludesVisibility();
          this.updateMainForm(event.target.value);
        });
      });

      // 【关键修改】在这里拦截主题的"加入购物车"按钮
      const mainCartButton = document.querySelector('.single-add-to-cart-button');
      if (mainCartButton && !mainCartButton.dataset.fbtListenerAttached) {
        mainCartButton.addEventListener('click', this.handleAddToCart.bind(this));
        mainCartButton.dataset.fbtListenerAttached = 'true';
      }
    }
    
    async handleAddToCart(event) {
      event.preventDefault(); // 阻止所有默认的加购行为

      const mainCartButton = event.currentTarget;
      const buttonText = mainCartButton.querySelector('.single-add-to-cart-button--text') || mainCartButton;
      const originalText = buttonText.textContent;

      mainCartButton.classList.add('loading');
      mainCartButton.disabled = true;
      buttonText.textContent = 'Adding...';

      // 1. 收集所有需要添加的商品
      const itemsToAdd = [];
      const mainVariantInput = this.mainProductForm.querySelector('input[name="id"]');
      
      // 【修复】读取数量选择器的实际值
      let mainQuantity = 1; // 默认值
      const quantityInput = document.querySelector('quantity-selector .qty');
      if (quantityInput) {
        mainQuantity = parseInt(quantityInput.value, 10) || 1;
      }
      
      console.log('=== ADD TO CART DEBUG ===');
      console.log('Main Variant ID:', mainVariantInput?.value);
      console.log('Main Quantity:', mainQuantity);
      
      if (mainVariantInput && mainVariantInput.value) {
        itemsToAdd.push({ id: mainVariantInput.value, quantity: mainQuantity });
      }

      // 2. 收集FBT商品(每个只添加1个)
      const fbtComponent = document.querySelector('fbt-bundle');
      if (fbtComponent) {
        const selectedFbtItems = fbtComponent.querySelectorAll('.fbt-item.is-selected');
        selectedFbtItems.forEach(item => {
          const fbtVariantId = item.dataset.variantId;
          console.log('FBT Item ID:', fbtVariantId);
          itemsToAdd.push({ id: fbtVariantId, quantity: 1 });
        });
      }
      
      console.log('Total items to add:', itemsToAdd);

      // 3. 使用分步添加逻辑
      try {
        for (const item of itemsToAdd) {
          const formData = new FormData();
          formData.append('id', item.id);
          formData.append('quantity', item.quantity);
          
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
          });
          
          const state = await response.json();
          if (state.status >= 400) {
            throw new Error(state.description || state.message);
          }
        }

        // 4. 所有商品添加成功后,获取并渲染最新的购物车
        const sectionsToRender = [
          { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
          { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
        ];
        const sectionsResponse = await fetch(`${window.location.pathname}?sections=${sectionsToRender.map(s => s.section).join(',')}`);
        const updatedSections = await sectionsResponse.json();
        
        // 渲染购物车抽屉和角标
        sectionsToRender.forEach(section => {
          const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          if (elementToReplace && updatedSections[section.section]) {
            const newHtml = new DOMParser().parseFromString(updatedSections[section.section], 'text/html').querySelector(section.selector).innerHTML;
            elementToReplace.innerHTML = newHtml;
          }
        });

        // 打开购物车抽屉
        const cartDrawer = document.getElementById('Cart-Drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        
        console.log('=== ADD TO CART SUCCESS ===');

      } catch (error) {
        console.error('Error:', error);
        alert('An error occurred while adding items to the cart. Please try again.');
      } finally {
        mainCartButton.classList.remove('loading');
        mainCartButton.disabled = false;
        buttonText.textContent = originalText;
      }
    }

    getVariantData() {
      if (this.variantData) {
        return this.variantData;
      }

      if (this.variantSelectsComponent && typeof this.variantSelectsComponent.getVariantData === 'function') {
        try {
          this.variantData = this.variantSelectsComponent.getVariantData();
          return this.variantData;
        } catch (error) {
          console.warn('Bundle selector could not read theme variant data:', error);
        }
      }

      if (!this.variantDataScript) {
        return [];
      }

      try {
        this.variantData = JSON.parse(this.variantDataScript.textContent);
        return this.variantData;
      } catch (error) {
        console.warn('Bundle selector could not parse variant data:', error);
        return [];
      }
    }

    getVariant(variantId) {
      return this.getVariantData().find(variant => String(variant.id) === String(variantId));
    }

    getSelectedRadio(variantId) {
      return Array.from(this.radioButtons).find(radio => String(radio.value) === String(variantId));
    }

    updateMainForm(variantId) {
      const variant = this.getVariant(variantId);

      if (this.mainProductForm) {
        const input = this.mainProductForm.querySelector('input[name="id"]');
        if (input) {
          input.value = variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (variant) {
        this.syncThemeVariantSelector(variant);
        this.updateMediaForVariant(variant, variantId);
        this.updateProductUrl(variant);
        this.dispatchVariantChange(variant);
      } else {
        this.updateMediaForVariant(null, variantId);
      }

      if (window.fbtBundleInstance && typeof window.fbtBundleInstance.triggerUpdate === 'function') {
        setTimeout(() => {
          window.fbtBundleInstance.triggerUpdate();
        }, 50);
      }
    }

    syncThemeVariantSelector(variant) {
      const selector = this.variantSelectsComponent;
      if (!selector || !variant) {
        return;
      }

      this.syncVariantControls(selector, variant);
      selector.currentVariant = variant;

      if (typeof selector.updateOptions === 'function') {
        selector.updateOptions();
      }
      if (typeof selector.updateVariantText === 'function') {
        selector.updateVariantText();
      }
      if (typeof selector.setDisabled === 'function') {
        selector.setDisabled();
      }
      if (typeof selector.updateVariantInput === 'function') {
        selector.updateVariantInput();
      }
      if (typeof selector.updatePickupAvailability === 'function') {
        selector.updatePickupAvailability();
      }
      if (typeof selector.renderProductInfo === 'function') {
        selector.renderProductInfo();
      }

      const stickyToggleText = selector.querySelector('.variant-selects--toggle-text');
      if (stickyToggleText) {
        stickyToggleText.textContent = variant.title;
      }
    }

    syncVariantControls(selector, variant) {
      if (!variant.options) {
        return;
      }

      const fieldsets = Array.from(selector.querySelectorAll('fieldset'));
      variant.options.forEach((optionValue, index) => {
        const fieldset = fieldsets[index];
        if (!fieldset) {
          return;
        }

        const select = fieldset.querySelector('select');
        if (select) {
          select.value = optionValue;
          return;
        }

        const input = Array.from(fieldset.querySelectorAll('input')).find(item => item.value === optionValue);
        if (input) {
          input.checked = true;
        }
      });
    }

    getVariantMediaId(variant, variantId) {
      if (variant && variant.featured_media && variant.featured_media.id) {
        return variant.featured_media.id;
      }

      const selectedRadio = this.getSelectedRadio(variantId);
      if (selectedRadio && selectedRadio.dataset.mediaId) {
        return selectedRadio.dataset.mediaId;
      }

      return null;
    }

    updateMediaForVariant(variant, variantId) {
      const mediaId = this.getVariantMediaId(variant, variantId);
      if (!mediaId || !this.productSlider) {
        return;
      }

      const slideSelector = `#Slide-${this.sectionId}-${mediaId}`;
      const thumbSelector = `#Thumb-${this.sectionId}-${mediaId}`;
      const activeMedia = this.productSlider.querySelector(slideSelector);
      const thumbnails = this.thumbnails || (this.productWrapper ? this.productWrapper.querySelector('.product-thumbnail-container') : null);

      if (!activeMedia) {
        return;
      }

      if (this.productSlider.dataset.hideVariants === 'true') {
        this.productSlider.querySelectorAll('.product-images__slide.is-initial-selected').forEach(slide => slide.classList.remove('is-initial-selected'));
        this.productSlider.querySelectorAll('.product-images__slide-item--variant').forEach(slide => slide.classList.remove('is-active'));
        activeMedia.classList.add('is-active', 'is-initial-selected');

        if (thumbnails) {
          thumbnails.querySelectorAll('.product-thumbnail.is-initial-selected').forEach(thumb => thumb.classList.remove('is-initial-selected'));
          thumbnails.querySelectorAll('.product-images__slide-item--variant').forEach(thumb => thumb.classList.remove('is-active'));
        }

        if (typeof this.productSlider.reInit === 'function') {
          this.productSlider.reInit();
        }
      }

      if (typeof this.productSlider.selectCell === 'function') {
        this.productSlider.selectCell(slideSelector);
      } else if (typeof Flickity !== 'undefined' && Flickity.data(this.productSlider)) {
        Flickity.data(this.productSlider).selectCell(slideSelector);
      }

      if (thumbnails) {
        thumbnails.querySelectorAll('.product-thumbnail.is-initial-selected').forEach(thumb => thumb.classList.remove('is-initial-selected'));
        const activeThumb = thumbnails.querySelector(thumbSelector);
        if (activeThumb) {
          activeThumb.classList.add('is-active', 'is-initial-selected');
          this.scrollThumbnailIntoView(activeThumb);
        }
      }
    }

    scrollThumbnailIntoView(thumbnail) {
      if (!thumbnail || !thumbnail.parentElement || thumbnail.offsetParent === null) {
        return;
      }

      const parent = thumbnail.parentElement;
      parent.scrollTo({
        left: thumbnail.offsetLeft - parent.clientWidth / 2 + thumbnail.clientWidth / 2,
        top: thumbnail.offsetTop - parent.clientHeight / 2 + thumbnail.clientHeight / 2,
        behavior: 'smooth'
      });
    }

    updateProductUrl(variant) {
      if (!variant || !window.history || !window.history.replaceState) {
        return;
      }

      const productUrl = this.variantSelectsComponent && this.variantSelectsComponent.dataset.url
        ? this.variantSelectsComponent.dataset.url
        : window.location.pathname;

      window.history.replaceState({}, '', `${productUrl}?variant=${variant.id}`);
    }

    dispatchVariantChange(variant) {
      const detail = {
        sectionId: this.sectionId,
        variant: variant
      };

      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('product:variant-change', detail);
      } else {
        document.dispatchEvent(new CustomEvent('product:variant-change', {
          detail: detail,
          bubbles: true
        }));
      }
    }

    updateIncludesVisibility() {
      const allGroups = this.container.querySelectorAll('.package-selector__variant-group');
      allGroups.forEach(group => {
        const radio = group.querySelector('.package-selector__radio-input');
        const includesContainer = group.querySelector('.package-includes-container');
        const includesContent = includesContainer ? includesContainer.querySelector('.package-includes__content') : null;
        if (radio && radio.checked && includesContent && includesContainer.innerText.trim() !== '') {
          includesContainer.style.display = 'block';
        } else if (includesContainer) {
          includesContainer.style.display = 'none';
        }
      });
    }
  }

  function initializeBundleSelectors() {
    const containers = document.querySelectorAll('.package-selector-container');
    containers.forEach(container => {
      const section = container.closest('.shopify-section');
      if (section) {
        container.dataset.sectionId = section.id.replace('shopify-section-', '');
      }
      if (!container.dataset.bundleInitialized) {
        new BundleSelector(container);
        container.setAttribute('data-bundle-initialized', 'true');
      }
    });
  }

  function runInitialSetup() {
    initializePjax();
    initializeBundleSelectors();
  }

  document.addEventListener('DOMContentLoaded', runInitialSetup);
  document.addEventListener('pjax:complete', initializeBundleSelectors);

})();
